import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { sendPageView } from '@/lib/analytics';
import { CookieConsentService } from '@/services/CookieConsentService';

const AnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Only track if analytics is allowed
        if (CookieConsentService.isAllowed('analytics')) {
            sendPageView(location.pathname + location.search);
        }
    }, [location]);

    return null;
};

export default AnalyticsTracker;
